/*global _ */
import contextProps from '../../../../../../props/context'
const localProps = {
  translations: {},
  settings: {},
  product: {},
  date: {},
  value: {},
  classes: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('classes', null)
    }
  },
  contentComponents: {
    type: [Array, Object],
    default() {
      return _.merge(
        {},
        this.$options.$$t('contentComponents', {}),
        this.$options.$$s('contentComponents', {})
      )
    }
  },
  datePickerComponent: {
    default() {
      return this.$options.$$s('date.component', 're-date-picker')
    }
  },
  datePickerAttrs: {
    default() {
      return _.merge(
        {},
        this.$options.$$t('date.attrs', {}),
        this.$options.$$s('date.attrs', {})
      )
    }
  },
  containerClasses: {
    default() {
      return this.$options.$$s('containerClasses', [])
    }
  },
  dateContainerClasses: {
    default() {
      return this.$options.$$s('date.containerClasses', [])
    }
  },
  timeslotsContainerClasses: {
    default() {
      return this.$options.$$s('timeslots.containerClasses', [])
    }
  },
  timeslotsErrorClasses: {
    default() {
      return this.$options.$$s('timeslots.errorClasses', [])
    }
  },
  timeslotsClasses: {
    default() {
      return this.$options.$$s('timeslots.classes', [])
    }
  },
  timeslotComponent: {
    default() {
      return this.$options.$$s('timeslot.component', null)
    }
  },
  timeslotAttrs: {
    default() {
      return _.merge(
        {},
        this.$options.$$t('timeslot.attrs', {}),
        this.$options.$$s('timeslot.attrs', {})
      )
    }
  },
  participants: {
    default() {
      return this.$options.$$s('participants', 1)
    }
  },
  minSlots: {
    default() {
      return this.$options.$$s('minSlots', 1)
    }
  },
  maxSlots: {
    default() {
      return this.$options.$$s('maxSlots', null)
    }
  },
  numConsecutiveSlots: {
    default() {
      return this.$options.$$s('numConsecutiveSlots', 1)
    }
  },
  allowSeparateSlots: {
    default() {
      return this.$options.$$s('allowSeparateSlots', false)
    }
  },
  initUseSeparateSlots: {
    default() {
      return this.$options.$$s('initUseSeparateSlots', false)
    }
  },
  messages: {
    default() {
      return this.$options.$$t('messages', {
        unavailable: 'Time options are not available for this date. Please select another date. ',
        unavailableTogether: 'Racing time options are not available for the selected number of participants. Please select book separately or select another date. ',
      })
    }
  }
}
export const props = {
  ...contextProps,
  ...localProps
}
export default props
